import React, { memo } from 'react';
import { AppointmentType } from '../../firebase/firestore/documents/appointmentAvaiability';

import { ReactComponent as _IconVideoCall } from '../../assets/img/video-accepted.svg';
import { ReactComponent as _IconAudioCall } from '../../assets/img/phone-accepted.svg';
import { ReactComponent as _IconPersonMeetCall } from '../../assets/img/appointment-accepted.svg';
import { ReactComponent as VideocamSvg } from '../../assets/img/videocam.svg';
import { ReactComponent as PhoneSvg } from '../../assets/img/phone-flash.svg';
import { ReactComponent as PersonSvg } from '../../assets/img/person.svg';

const VideoImage = memo(_IconVideoCall);
const AudioImage = memo(_IconAudioCall);
const PersonMeetImage = memo(_IconPersonMeetCall);

interface ScheduleIconProps {
  type: AppointmentType | string;
  isAdhoc?: boolean;
  bookingId: string;
}

export const ScheduleIcon: React.FC<ScheduleIconProps> = ({ type, isAdhoc, bookingId }) => {
  if (isAdhoc) {
    if (type === AppointmentType.video) {
      return <VideocamSvg data-testid={`${type}-adhoc-${bookingId}`} />;
    }
    if (type === AppointmentType.phone) {
      return <PhoneSvg data-testid={`${type}-adhoc-${bookingId}`} />;
    }
    return <PersonSvg data-testid={`${type}-adhoc-${bookingId}`} />;
  }

  if (type === AppointmentType.video) {
    return <VideoImage data-testid={`${type}-${bookingId}`} />;
  }
  if (type === AppointmentType.phone) {
    return <AudioImage data-testid={`${type}-${bookingId}`} />;
  }
  return <PersonMeetImage data-testid={`${type}-${bookingId}`} />;
};
